import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import {
  INVOICE_TYPE_ORDERAWNING,
  isNullEmptyOrWhitespace,
  IsNullOrUndefined,
  ORDER_STATUS_ORDER_REQUESTED,
  ROLE_OrderFAA,
  view_order_editable_order_and_awning_note_all,
  view_order_save_order_all,
} from "../../constants";
import {apiPost, apiRequest} from "../../utils/request";
import {toastr} from "react-redux-toastr";
import SelectControl from "../common/SelectControl";
import OrderProductionSheet from "../orders/OrderProductionSheet";
import OrderFabricSheet from "../fabric/OrderFabricSheet";
import OrderDispatchSheet from "../orders/OrderDispatchSheet";
import OrderFlashingSheet from "../orders/OrderFlashingSheet";
import OrderColorbondHoodSheet from "../orders/OrderColorbondHoodSheet";
import OrderDiagramsSheet from "../awningdiagrams/OrderDiagramsSheet";
import NolanOrderSheet from './NolanOrderSheet';
import {ButtonWrapper} from "../orders/OrderSummaryPage";
import AwningSummaryView from "../orders/AwningSummaryView";

class FabricationOrdersViewPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: null,
      loaded: false,
      isViewSelectedSheet: false,
      isPrintSelectedSheet: false,
      selectedSheet: null,
      colorBondColours: [],
      notifying: false,
    };

    this.fetchColorBondColours = this.fetchColorBondColours.bind(this);
    this.loadOrder = this.loadOrder.bind(this);
    this.notifyGroup = this.notifyGroup.bind(this);
  }
  
  // Tells the group that fabricates this order that it is ready for review. The recipient is
  // resolved server side from the order's organisation group, never posted by the client.
  notifyGroup(e) {
    e.preventDefault();
    let {order} = this.state;

    // A FABMOD-role user placing/notifying an order is doing so as a sub-order of KC Shades,
    // not directly of Nolans -- the actual recipient email is unchanged, only the displayed name.
    let displayName = this.props.user.isInRole(ROLE_OrderFAA) ? 'KC Shades' : order.organisationGroupShortName;

    this.setState({notifying: true});

    apiPost(`/api/fabrications/${this.props.fabricationOrderId}/email/notify`, {})
        .then(x => {
          this.setState({notifying: false});
          if (!x.error) {
            toastr.success(`${displayName} has been notified`);
          }
        })
        .catch(x => {
          console.log(x);
          this.setState({notifying: false});
          toastr.error(`Error notifying ${displayName} ` + x);
        });
  }

  componentWillMount() {
    this.loadOrder();
    this.fetchColorBondColours();
  }

  componentDidMount() {
    if(this.state.loaded === false) {
      this.loadOrder();
    }
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {

    if(this.props.selectedSheet && !this.state.selectedSheet){
      this.setState({selectedSheet: {...this.props.selectedSheet}});

      setTimeout(() => {
        this.setState({isViewSelectedSheet: false});
      }, 1000);
    }
  }
  
  loadOrder(){
    if(this.props.fabricationOrderId > 0){
      apiRequest (`/api/fabrications/?id=${this.props.fabricationOrderId}`)
        .then(x => {
          this.setState({order: x.data, loaded: true});
        });
    }
  }

  fetchColorBondColours() {
    apiRequest(`/api/colours/colorbond`)
        .then(x => {
          if (!x.error) {
            this.setState({colorBondColours: x.data});
          }
        });
  }

  selectedSheetToggleOpen(resetSheet = false){
    if(this.state.isViewSelectedSheet){
      this.setState({isViewSelectedSheet: false, selectedSheet: resetSheet ? null : this.state.selectedSheet});
    }
  }
  
  selectedSheetIndex(sheetName) {
    return (this.state.selectedSheet && (this.state.isViewSelectedSheet || this.state.isPrintSelectedSheet) && this.state.selectedSheet.value.sheetName == sheetName) ?
        this.state.selectedSheet.value.index : -1;
  }

  selectedSheetIsOpen(sheetName) {
    return (this.state.selectedSheet && (this.state.isViewSelectedSheet || this.state.isPrintSelectedSheet) && this.state.selectedSheet.value.sheetName == sheetName) ? true : false;
  }

  selectedSheetIsPrint(sheetName){
    return (this.state.selectedSheet && this.state.isPrintSelectedSheet && this.state.selectedSheet.value.sheetName == sheetName) ? true : false;
  }
  

  render(){
    let {order} = this.state;
    let {user} = this.props;

    let buttonList = [];
    
    // A distributor only ever needs the diagrams -- the production, fabric and dispatch
    // paperwork is for the group that fabricates the order.
    let isDistributor = !isNullEmptyOrWhitespace(user.distributorName);

    if (order && isDistributor){
      buttonList.push({value: {sheetName: 'abs'}, label: 'Order Diagrams'});
    }

    if (order && !isDistributor){
      buttonList.push({value: { sheetName: 'production'}, label: 'Production Sheet'});
      if(order.fabricSheets){
        for(let i= 0; i < this.state.order.fabricSheets.length; i++){
          buttonList.push({value: { sheetName: 'fabric', index: i}, label: `Fabric Sheet #${i+1}`});
        }
      }
      if(order.awnings.filter(a => a.flashingType).length > 0){
        buttonList.push({value: { sheetName: 'flashing'}, label: 'Flashing Sheet'});
      }
      if(order.awnings.filter(a => a.hasColorbondHood).length > 0){
        buttonList.push({value: { sheetName: 'colorbondHood'}, label: 'Colorbond Hood Sheet'});
      }
      if(order.dispatchSheet){
        buttonList.push({value: { sheetName: 'dispatch'}, label: 'Dispatch Sheet'});
      }
      buttonList.push({value: {sheetName: 'abs'}, label: 'Order Diagrams'});
      if(!user.isInRole(ROLE_OrderFAA)) {
        buttonList.push({value: {sheetName: 'nolan'}, label: 'Nolan Order Sheet'});
      }
    }


    return this.state.loaded ? (
      <div style={{minHeight:'1700px'}}>
        <h4 className="mt-4">Fabrication Orders View Page</h4>

        <div className="pi-row">
          <div className="pi-col-md-8">
            <div className="button-container" style={{
              display: 'flex',
              gap: '12px',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <button
                  className="btn btn-secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push(`/fabricationOrders/list`);
                  }}
              >
                <i className="fa fa-arrow-left"/>&nbsp;List
              </button>
              <button
                  className="btn btn-info"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push(`/fabricationOrders/edit/${this.props.fabricationOrderId}`);
                  }}
              >
                <i className="fa fa-edit fa-lg"/>&nbsp;Edit
              </button>

              <button
                  className="btn pi-btn-base pi-uppercase pi-letter-spacing"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push(`/fabricationOrders/create`);
                  }}
              >
                <i className="fa fa-plus" />&nbsp;Create New
              </button>

              { isDistributor && !IsNullOrUndefined(order) &&
                  <button
                      className="btn btn-warning"
                      disabled={this.state.notifying}
                      onClick={this.notifyGroup}
                  >
                    <i className="fa fa-envelope"/>&nbsp;Notify {order.organisationShortName}
                  </button> }

              { !isDistributor && !IsNullOrUndefined(order) && !user.isInRole(ROLE_OrderFAA) &&
                  <button
                      className="btn btn-primary"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({
                          selectedSheet: {value: {sheetName: 'nolan'}, label: 'Nolan Order Sheet'},
                          isViewSelectedSheet: true,
                          isPrintSelectedSheet: false,
                        });
                      }}
                  >
                    <i className="fa fa-binoculars"/>&nbsp;Review/Place Order
                  </button> }
            </div>
          </div>
        </div>
        
        { !IsNullOrUndefined(order) && 
            <>
              <div>
                <SelectControl
                    onChange={(v) => {
                      this.setState({selectedSheet: v});
                    } }
                    clearable={true}
                    deleteRemoves={true}
                    backspaceRemoves={true}
                    name={'selectedSheet'}
                    value={this.state.selectedSheet}
                    options={buttonList}
                    simpleValue={false}
                    placeholder={'View order...'}
                />
              </div>
              <div>
                <ButtonWrapper
                    visible={this.state.selectedSheet!==null}
                    onClick={()=> this.setState({isViewSelectedSheet: true, isPrintSelectedSheet: false})}
                    className="btn pi-btn-base pi-uppercase pi-weight-700 pi-letter-spacing"
                    style={{marginRight: '10px'}}>
                  <i className="fa fa-binoculars pi-icon-left"/>&nbsp;View {this.state.selectedSheet !== null ? this.state.selectedSheet.label : ''}
                </ButtonWrapper>

                <ButtonWrapper
                    visible={this.state.selectedSheet!==null}
                    onClick={()=> this.setState({isViewSelectedSheet: false, isPrintSelectedSheet: true})}
                    className="btn pi-uppercase pi-weight-700 pi-letter-spacing"
                    style={{marginRight: '10px'}}>
                  <i className="fa fa-print pi-icon-left"/>&nbsp;Print {this.state.selectedSheet !== null ? this.state.selectedSheet.label : ''}
                </ButtonWrapper>
              </div>

              <OrderProductionSheet
                  order={order}
                  toggleOpen={() => this.selectedSheetToggleOpen()}
                  isOpen={this.selectedSheetIsOpen('production')}
                  print={this.selectedSheetIsPrint('production')}
                  theme={this.props.theme}
                  isFabricationOrder={true}
              />

              <OrderFabricSheet
                  order={order}
                  toggleOpen={() => this.selectedSheetToggleOpen()}
                  fabricSheetIndex={this.selectedSheetIndex('fabric')}
                  isOpen={this.selectedSheetIsOpen('fabric')}
                  print={this.selectedSheetIsPrint('fabric')}
                  showEmail={!user.isInRole(ROLE_OrderFAA)}
                  showSequenceNumber={false}
                  orderType={INVOICE_TYPE_ORDERAWNING}
                  theme={this.props.theme}
              />

              <OrderFlashingSheet
                  order={order}
                  toggleOpen={() => this.selectedSheetToggleOpen()}
                  isOpen={this.selectedSheetIsOpen('flashing')}
                  colorBondColours={this.state.colorBondColours}
                  print={this.selectedSheetIsPrint('flashing')}
                  theme={this.props.theme}
                  isFabricationOrder={true}
                  user={user}
              />

              <OrderColorbondHoodSheet
                  order={order}
                  toggleOpen={() => this.selectedSheetToggleOpen()}
                  isOpen={this.selectedSheetIsOpen('colorbondHood')}
                  colorBondColours={this.state.colorBondColours}
                  print={this.selectedSheetIsPrint('colorbondHood')}
                  theme={this.props.theme}
                  isFabricationOrder={true}
                  user={user}
              />

              {!IsNullOrUndefined(order.dispatchSheet) &&
                  <OrderDispatchSheet
                      order={order}
                      toggleOpen={() => this.selectedSheetToggleOpen()}
                      isOpen={this.selectedSheetIsOpen('dispatch')}
                      print={this.selectedSheetIsPrint('dispatch')}
                      theme={this.props.theme}
                      isFabricationOrder={true}
                  />
              }

              <OrderDiagramsSheet
                  order={order}
                  toggleOpen={() => this.selectedSheetToggleOpen()}
                  isOpen={this.selectedSheetIsOpen('abs')}
                  print={this.selectedSheetIsPrint('abs')}
                  theme={this.props.theme}
              />
              {!user.isInRole(ROLE_OrderFAA) &&
                <NolanOrderSheet
                    order={order}
                    toggleOpen={() => this.selectedSheetToggleOpen()}
                    isOpen={this.selectedSheetIsOpen('nolan')}
                    print={this.selectedSheetIsPrint('nolan')}
                    theme={this.props.theme}
                />
              }
            </>
        }

        <div className="pi-col-sm-6" style={{paddingTop: '20px'}}>
          {order.awnings.filter(x => IsNullOrUndefined(x.parentOrderAwningId)).map((awning, i) => <div key={awning.id}>
            {i > 0 && <div className={'html2pdf__page-break'}/> }
            <AwningSummaryView
                ref={`awning_${awning.id}`}
                awning={awning}
                awningCount={order.awnings.filter(x => IsNullOrUndefined(x.parentOrderAwningId)).length}
                awningSetCount={order.awnings.filter(x => !IsNullOrUndefined(x.parentOrderAwningId)).length}
                onChange={this.awningChanged} 
                orderStatus={order.orderStatus}
                order={order}
                canAddNote={true}
                canEditJoiner={false}
                canEditFabricInstructions={ (user.hasAccessTag(view_order_editable_order_and_awning_note_all) && order.orderStatus == ORDER_STATUS_ORDER_REQUESTED) }
                onExpandArmBracketSheet={this.openAbsSheet}
                canEditAttachment={user.hasAccessTag(view_order_save_order_all)}
                canEditMotor={false}
                notesReadOnly={true}
            />
          </div>)}
        </div>
      </div>
        
    ):(<div className="pi-section">
          <div className="pi-row">
            <div className="pi-col-md-8">
              <h4 className="pi-has-bg pi-margin-bottom-20">
                Loading... <i className={'fa fa-spinner fa-spin'} />
              </h4>
            </div>
          </div>
        </div>);
  }
}

FabricationOrdersViewPage.propTypes = {
  fabricationOrderId: PropTypes.number.isRequired,
  user: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  let fabricationOrderId = -1;
  if(ownProps.match.params && ownProps.match.params.fabricationOrderId){
    fabricationOrderId = parseInt(ownProps.match.params.fabricationOrderId);
  }
  
  return {
    fabricationOrderId,
    user: state.user,
    siteSettings: state.lookups.siteSettings,
    theme: state.theme,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FabricationOrdersViewPage));